export const STREAM_SERVER = window._env_.STREAM_SERVER;
export const FINDING_STREAM_SERVER = window._env_.FINDING_STREAM_SERVER || "https://bdtv.nhungnv.com";
